import { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  error,
  errorinvoice,
  LabOrder,
  lmsIntent,
  optionValue,
  OrderEvent,
  orderMsg,
  orderSubmit,
  orderValidationmsg,
  Panel,
  priceFailedMsg,
  PriceList,
  priceListNotFound,
  Row,
  success,
} from '../../labTests/models'
import { startSxpProxy } from '../../../utils/api'
import { LABS_PROJECT_ID } from '../../../utils/constants'
import { toast } from 'react-toastify'
import ToastMessage from '../../lms/components/ToastMessage'
import { toastOptions } from '../../lms/models'
import { saveOrder } from '../../labTests/utils'
import KeycloakService from '../../../utils/keycloakService'
import { LAB_ORDERS_WRITE } from '../../../utils/roles'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import {
  selectLocationById,
  selectSelectedLocationId,
} from '../../location/locationSlice'
import { prepareOrderEventTests } from '../../lms/utils'
import { Doctor } from '../../scheduler/schedulerSlice'
import { useOrganizations } from '../../lms/components/useOrganizations'
import {
  fetchSlotsDoctorsAsync,
  selectSlotsDoctors,
} from '../../slots/slotsSlice'
import { setQueryParam } from '../../membership/membershipSlice'
import {
  Box,
  Button,
  Paper,
  Typography,
  Alert,
  Divider,
  Autocomplete,
  TextField,
} from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import { labordercreate } from '../../bedManagement/endpoints/EndPoints'
import {
  CreateLabInvoice,
  getOdooProductPrice,
} from '../../../services/LmsService'
import PackageTests from '../../labTests/PackageTests'
import { modes } from '../../Radiology/Constants/constants'
import { createCampLabOrder } from '../../../services/CampManagementService'
import PaymentMethodSelector from './components/PaymentMethodSelector'
import LabTestTable from './components/LabTestTable'
import TestParametersList from './components/TestParametersList'
import { makeStyles } from '../../../utils/hooks/makeStyles'

const useStyles = makeStyles(() => ({
  container: {
    padding: 24,
    backgroundColor: '#f5f7fa',
    minHeight: '100vh',
  },
  paper: {
    padding: 24,
    borderRadius: 8,
    maxWidth: '1400px',
    margin: '0 auto',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  header: {
    marginBottom: 24,
  },
  headerTitle: {
    fontWeight: 600,
    color: '#1976d2',
    marginBottom: 8,
  },
  divider: {
    marginBottom: 24,
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
    flexWrap: 'wrap',
    gap: 16,
    backgroundColor: '#fff',
    padding: 16,
    borderRadius: 8,
    border: '1px solid #e0e0e0',
  },
  alert: {
    maxWidth: 600,
  },
  actionButtons: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  submitButton: {
    marginTop: '15px !important',
    minWidth: 140,
    height: 48,
    textTransform: 'none',
    fontWeight: 600,
    backgroundColor: '#4caf50',
    '&:hover': {
      backgroundColor: '#45a049',
    },
    '&:disabled': {
      backgroundColor: '#ccc',
    },
  },
}))

interface OpdOrderProps {
  muhId: string
  fhirId: string
  campId: string
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>
  fetchAllLabOrders: (id: string) => void
}

const CreateLabOrder: React.FC<OpdOrderProps> = ({
  muhId,
  fhirId,
  campId,
  setOpenDialog,
  fetchAllLabOrders,
}) => {
  const classes = useStyles()
  const id: any = fhirId
  const patientUhid: any = muhId
  const [newrowadded, setNewRowAdded] = useState(false)
  const [order, setOrder] = useState<LabOrder>({})
  const [origin, setOrigin] = useState('OPD')
  const locationId = useAppSelector(selectSelectedLocationId)
  const location = useAppSelector((state) =>
    selectLocationById(locationId, state)
  )
  const [selectedTests, setSelectedTests] = useState<any[]>([])
  const [rows, setRows] = useState<Row[]>([])
  const [isRowAdded] = useState(false)
  const [testAdded, setTestAdded] = useState(false)
  const [testNameOptions, setTestNameOptions] = useState<
    { label: string; value: string; panels: any; odoo_testId: any }[]
  >([])
  const [newRow, setNewRow] = useState<Row>({
    mode: null,
    requestedBy: null,
    sampleName: null,
    testName: null,
    panel: null,
    origin: null,
    price: 0,
    panels: null,
    packagePrice: 0,
    OdooPackageId: 0,
    productName: '',
    discount: 0,
  })
  const [isSaving, setIsSaving] = useState(false)
  const [priceLoading, setPriceLoading] = useState(false)
  const [externalText, setExternalText] = useState('')
  const [paymentMethod, setPaymentMethod] = useState<{
    label: string
    value: string
  } | null>(null)
  const reqPatnerId = newRow?.requestedBy?.odooId
  const dispatch = useAppDispatch()

  const paymentOptions = [
    { label: 'Cash', value: 'CASH' },
    { label: 'UPI', value: 'UPI' },
  ]
  const handleModeChange = (selectedOption: any) => {
    setRows([])
    setNewRow((prev: any) => ({
      ...prev,
      mode: selectedOption,
      panels: [],
      testName: null,
      packageId: null,
      packageName: '',
      packagePrice: 0,
      OdooPackageId: null,
      allPanelNames: '',
    }))
    setNewRowAdded(true)
  }
  const executeFunction = () => {
    const state = {}
    startSxpProxy(LABS_PROJECT_ID, 'getAllPanelsApi', state)
      ?.then((data) => {
        const panelData: any = data?.data?.panel ?? []
        const tests = panelData?.map((test: any) => ({
          label: test?.name,
          value: String(test?.id),
          odoo_test_id: test?.odoo_test_id,
          sampleName: test?.sample?.name,
          sampleId: test?.sample?.id,
          panel: {
            name: test?.name,
            description: test?.description,
            id: test?.id,
            odoo_test_id: test?.odoo_test_id,
            lab_tests: test?.lab_tests,
            sampleId: parseInt(test?.sample?.value ?? '0'),
            sampleName: test?.sample?.name,
            processing_unit: '',
            price: test?.price ?? 0,
          },
        }))
        const selectedTestLabels =
          rows?.map((row) => row?.testName?.label) ?? []
        const filteredTests =
          tests?.filter(
            (test: any) => !selectedTestLabels.includes(test?.label)
          ) ?? []
        setTestNameOptions(filteredTests)
      })
      .catch((error) => {
        console.error('Error fetching test names:', error)
        setTestNameOptions([])
      })
  }
  const handleTestNameChange = async (selectedOption: any) => {
    if (!selectedOption) return
    const updatedRow: any = {
      testName: {
        label: selectedOption?.label,
        value: selectedOption?.value,
        odoo_test_id: selectedOption?.odoo_test_id,
      },
      sampleName: {
        label: selectedOption?.panel?.sampleName,
        value: selectedOption?.panel?.sampleId,
      },
      panel: selectedOption?.panel,
    }

    const priceList = location?.resource?.type?.[0]?.coding?.find(
      (item: any) => item?.code === PriceList
    )?.display
    setPriceLoading(true)
    const b2bOrigin = origin === 'B2B'
    const reqDoctorRef = newRow?.requestedBy?.doctorRef
    try {
      const response = await getOdooProductPrice({
        selectedLocationId: location?.resource?.id ?? '',
        patient_identifier: id ?? '',
        partner_id: newRow?.requestedBy?.odooId ?? '',
        odootestid:
          selectedOption?.panel?.odoo_test_id ??
          selectedOption?.OdooPackageId ??
          '',
        pricelist_id: priceList ?? '',
        b2b: b2bOrigin,
        reqOdooId: reqPatnerId ?? '',
        doctor_id: reqDoctorRef ?? '',
      })

      const rawPrice =
        response?.data?.best_price ?? response?.data?.data?.best_price ?? 0
      const defaultPrice = response?.data?.default_price ?? 0
      const price = Number(rawPrice)
      // eslint-disable-next-line camelcase
      const pricelist_id = response?.data?.pricelist_id
      const discount =
        response?.data?.discount_percent ??
        response?.data?.data?.discount_percent ??
        0
      if (!Number?.isFinite(price)) {
        throw new Error(priceListNotFound)
      }
      updatedRow.price = price
      updatedRow.discount = discount
      updatedRow.panel = {
        ...updatedRow?.panel,
        price,
        discount,
        defaultPrice,
        // eslint-disable-next-line camelcase
        pricelist_id: pricelist_id,
        best_price: price,
      }
      setNewRow((prev) => ({ ...prev, ...updatedRow }))
    } catch (e: any) {
      const errorMsg = e?.response?.data?.message || priceFailedMsg
      toast(<ToastMessage message={errorMsg} />, {
        ...toastOptions,
        type: error,
      })
    } finally {
      setPriceLoading(false)
    }
  }
  const products = rows
    ?.map((row: any) => ({
      product_id:
        row?.panel?.odoo_test_id || row?.OdooPackageId || order?.package_id,
      price: row?.panel?.defaultPrice ?? 0,
      discount_percent: row?.panel?.discount ?? 0,
      pricelist_id: row?.panel?.pricelist_id ?? null,
      best_price: row?.panel?.best_price ?? row?.panel?.price ?? 0,
    }))
    ?.filter((e: any) => e?.product_id)

  const handleSave = async () => {
    if (!KeycloakService.hasRole([LAB_ORDERS_WRITE])) return
    if (!rows?.[0]?.testName) {
      toast(<ToastMessage message={orderValidationmsg} />, {
        ...toastOptions,
        type: error,
      })
      return
    }
    setIsSaving(true)
    const filteredPanels: Panel[] =
      rows?.flatMap((row: Row) =>
        row?.mode?.value === modes?.test ? [row?.panel] : row?.panels || []
      ) ?? []
    const filteredLabTests: any = []
    // const mode: 'visit' | 'patient' = locations.pathname.startsWith(visits)
    //   ? visit
    //   : patientText
    // const doctorName = await getDoctorForVisit(id ?? '')
    const locationName = location?.resource?.name ?? ''
    const locationId = location?.resource?.id ?? ''
    const requestedBy =
      rows?.[rows?.length - 1]?.requestedBy?.value ===
      optionValue?.external?.value
        ? externalText
        : rows?.[rows?.length - 1]?.requestedBy?.value ?? ''
    const reqOdooId = rows?.[rows?.length - 1]?.requestedBy?.odooId
    const reqDoctorRef = rows?.[rows?.length - 1]?.requestedBy?.doctorRef
    const packageId = rows?.[rows?.length - 1]?.packageId

    try {
      // Step 1: Create Lab Invoice
      const invoiceResponse = await CreateLabInvoice(
        locationId,
        origin,
        products,
        patientUhid,
        reqOdooId || null,
        reqDoctorRef,
        rows?.[0]?.mode?.value || ''
      )

      const response = invoiceResponse?.data
      if (response?.odooApistatus === error) {
        toast(
          <ToastMessage message={response?.message || orderMsg?.failedmsg} />,
          { ...toastOptions, type: error }
        )
        setIsSaving(false)
        return
      }

      // Step 2: Extract invoice details
      const odooInvoiceID = invoiceResponse?.data?.odoo_invoice_id || ''
      const RefID = invoiceResponse?.data?.ref_id || ''

      // Step 3: Save Lab Order
      const saveOrderResponse = await saveOrder(
        'patient',
        order,
        id,
        id,
        filteredPanels,
        filteredLabTests,
        locationName,
        packageId || 0,
        0,
        requestedBy,
        origin,
        odooInvoiceID,
        RefID,
        locationId
      )

      // Step 4: Extract order lab
      const orderLab: LabOrder = saveOrderResponse?.data?.insert_lab_orders_one

      setOrder(orderLab)

      // Step 5: Create order event
      const stateObj: Partial<OrderEvent> = {
        updated_by: KeycloakService.getUsername(),
        order_id: orderLab?.id,
        type: 'ORDERED',
        tests: prepareOrderEventTests(
          filteredPanels,
          filteredLabTests,
          'ORDERED'
        ),
      }

      await startSxpProxy(LABS_PROJECT_ID, lmsIntent?.createOrderEvent, {
        event: stateObj,
      })

      // Step 6: Create camp lab order
      const campPayload = {
        patientUhid: patientUhid,
        patientFhirId: id,
        invoiceId: odooInvoiceID,
        order: orderLab,
        paidTest: true,
        journal: paymentMethod?.value ?? '',
        refId: RefID,
        campId: campId,
        mode: rows?.[0]?.mode?.value === modes?.test,
      }

      try {
        await createCampLabOrder(campPayload)
      } catch (campError: any) {
        console.error('Camp order creation failed:', campError)
        // Continue execution even if camp order fails
      }

      setOpenDialog(false)
      fetchAllLabOrders(id)
      toast(<ToastMessage message={orderSubmit} />, {
        ...toastOptions,
        type: success,
      })
      setNewRowAdded(false)
      setOrder({})
    } catch (err: any) {
      toast(<ToastMessage message={err?.message || errorinvoice} />, {
        ...toastOptions,
        type: error,
      })
    } finally {
      setIsSaving(false)
    }
  }

  const handleSaveRow = () => {
    if (!newRow?.testName) {
      alert(orderMsg?.TestName)
      return
    }
    const reqBy =
      rows?.length > 0 ? rows?.[0]?.requestedBy : newRow?.requestedBy
    const org = rows?.length > 0 ? rows?.[0]?.origin : newRow?.origin
    const updatedRows = [
      ...rows,
      {
        ...newRow,
        requestedBy: reqBy,
        origin: org,
      },
    ]
    setRows(updatedRows)
    const nextRow = {
      mode: newRow?.mode,
      requestedBy: reqBy,
      origin: org,
      sampleName: null,
      testName: null,
      panel: null,
      price: 0,
    }
    setNewRow(nextRow)
    setNewRowAdded(true)
    if (newRow?.testName) {
      setSelectedTests([...selectedTests, newRow?.testName])
    }
    setTestAdded((prev) => !prev)
  }

  const handleRequestedByChange = (selectedOption: any) => {
    setNewRow((prev) => ({
      ...prev,
      requestedBy: selectedOption,
      panels: [],
      testName: null,
      panel: null,
      packageId: undefined,
      packagePrice: 0,
      OdooPackageId: undefined,
      productName: '',
      allPanelNames: '',
    }))
  }

  const handleOriginChange = (selectedOption: any) => {
    const selectedValue = selectedOption?.value || ''
    setOrigin(selectedValue)
    setNewRow((prev) => ({ ...prev, origin: selectedOption }))
  }
  const organizations = useOrganizations()
  const doctors = useAppSelector(selectSlotsDoctors)
  const handleDeleteRow = (index: number) => {
    setRows((prevRows: Row[]) => {
      const updatedRows = [...prevRows]
      updatedRows?.splice(index, 1)
      return updatedRows
    })
    setNewRowAdded(true)
  }

  useEffect(() => {
    dispatch(fetchSlotsDoctorsAsync())
  }, [dispatch])

  const VisitTableRef = useRef<HTMLDivElement | null>(null)
  //   const fetchData = async () => {
  //     try {
  //       const labOrderData = await startSxpProxy(
  //         LABS_PROJECT_ID,
  //         lmsIntent?.getLabOrdersByPatientIdForOpd,
  //         { patientId: id, source: location?.resource?.name }
  //       )
  //       //   const orders: LabOrder[] = labOrderData?.data?.lab_orders ?? []
  //       //   setOrders(orders)
  //       //   handleActiveOrderChage(orders)
  //     } catch (err) {
  //       console.error(err)
  //     }
  //   }

  //   const getAllLabOrders = () => {
  //     const intent = 'getLabOrdersByPatientIds'
  //     startSxpProxy(LABS_PROJECT_ID, intent, { patientId: fhirId })
  //       ?.then((data: any) => {
  //         const orders: LabOrder[] = data?.data?.lab_orders ?? []
  //         setOrders(orders)
  //         handleActiveOrderChage(orders)
  //         const state = { encounterId: id }
  //         startSxpProxy(OPD_PROJECT_ID, lmsIntent?.getVisitApi, state)
  //           ?.then((data) => {
  //             setPatientId(data?.data?.subject?.reference?.split('/')?.[1])
  //             SetVisitStatus(data?.data?.statusHistory?.[0]?.status)
  //           })
  //           .catch((err) => {
  //             console.log(err)
  //           })
  //       })
  //       .catch((err) => {
  //         console.log(err)
  //       })
  //   }

  //   useEffect(() => {
  //     if (window.location.pathname === `${labordercreate}/${id}`) {
  //       fetchData()
  //     }

  //     else {
  //       getAllLabOrders()
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [id])
  //   const handleActiveOrderChage = (orders: LabOrder[]) => {
  //     let activeOrder: any = {}
  //     // needed
  //     // if (window.location.pathname?.startsWith(labordercreate)) {
  //     //   const latestOrder = orders?.[orders?.length - 1]

  //     //   activeOrder =
  //     //     latestOrder?.order_events?.every((event) =>
  //     //       event?.tests?.every(
  //     //         (test) =>
  //     //           test.status === `${orderStatus?.orderedModified}` ||
  //     //           test.status === `${orderStatus?.ordered}`
  //     //       )
  //     //     ) && latestOrder.origin !== AB
  //     //       ? latestOrder
  //     //       : orders?.[-1] ?? {}
  //     // } else
  //     {
  //       activeOrder = orders[activeIndex] ?? {}
  //     }
  //     setOrder(activeOrder)
  //     const formattedRows: any = activeOrder?.panels?.map((panel: any) => {
  //       return {
  //         mode: {
  //           label: activeOrder?.package_id ? 'Package' : 'Test',
  //           value: activeOrder?.package_id ? 'package' : 'test',
  //         },
  //         requestedBy: {
  //           label: activeOrder?.requested_by,
  //           value: activeOrder?.requested_by,
  //         },
  //         origin: {
  //           label: activeOrder?.origin,
  //           value: activeOrder?.origin,
  //         },
  //         sampleName:
  //           panel?.sampleName && panel?.sampleId
  //             ? { label: panel?.sampleName, value: panel?.sampleId }
  //             : null,

  //         testName:
  //           panel?.name && panel?.id
  //             ? { label: panel?.name, value: panel?.id }
  //             : null,
  //         panel: panel || null,
  //       }
  //     })
  //     setRows(formattedRows || [])
  //     setOrdersEvent(activeOrder?.order_events ?? [])
  //     setOrder(activeOrder)
  //     if (
  //       activeOrder?.id &&
  //       activeOrder?.panels &&
  //       activeOrder?.panels?.length >= 1
  //     ) {
  //       setNewRow({
  //         mode: {
  //           label: activeOrder?.package_id ? 'Package' : 'Test',
  //           value: activeOrder?.package_id ? 'package' : 'test',
  //         },
  //         requestedBy: null,
  //         sampleName: null,
  //         testName: null,
  //         panel: null,
  //         origin: null,
  //       })
  //     } else {
  //       setNewRow({
  //         mode: null,
  //         requestedBy: null,
  //         sampleName: null,
  //         testName: null,
  //         panel: null,
  //         origin: null,
  //       })
  //     }
  //   }

  useEffect(() => {
    const resizeHandler = () => {
      const container = VisitTableRef.current
      if (container) {
        const availableHeight =
          window.innerHeight - container.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 90}px`
      }
    }
    window.addEventListener('resize', resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener('resize', resizeHandler)
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  useEffect(() => {
    executeFunction()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testAdded, rows])

  //   useEffect(() => {
  //     handleActiveOrderChage(orders)
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [activeIndex])

  const locations = useLocation()

  useEffect(() => {
    if (locations.pathname.startsWith(labordercreate)) {
      setNewRow((prevState) => ({
        ...prevState,
        origin: optionValue?.origin,
      }))
    }
  }, [locations.pathname, setNewRow])
  //   const handleIndexChange = (index: any) => {
  //     setActiveIndex(index)
  //     setNewRowAdded(false)
  //   }
  //   const isPointerEventsDisabled = ordersEvent?.some((event) =>
  //     event.tests?.some(
  //       (test) => test.status !== 'ORDER_MODIFIED' && test.status !== 'ORDERED'
  //     )
  //   )
  const getRequestedByOptions = () => {
    const selfOption = optionValue?.self
    const externalOption = optionValue?.external

    const dynamicOptions =
      newRow?.origin?.value === optionValue?.b2b?.value
        ? organizations?.map((org: any) => ({
            value: org?.name,
            label: org?.name,
            odooId: org?.odoo_partner_id,
          }))
        : doctors?.map((d: Doctor) => {
            const qualificationPart = d?.qualification
              ? ` (${d?.qualification?.toUpperCase()})`
              : ''
            const specialtyPart = d?.specialty ? ` [${d?.specialty}]` : ''
            const displayName =
              `Dr. ${d?.name}${qualificationPart}${specialtyPart}`.trim()
            const doctorRef = d?.id
            return {
              value: displayName,
              label: displayName,
              doctorRef: doctorRef,
            }
          }) || []

    return [selfOption, ...dynamicOptions, externalOption]
  }
  const renderParameters = (parameters: any) => {
    return <TestParametersList parameters={parameters} />
  }

  const renderTestOrPackage = () => {
    if (newRow?.mode?.value === modes?.package) {
      return (
        <PackageTests
          key={`${newRow.mode?.value}-${newRow.requestedBy?.value ?? ''}`}
          id={order?.package_id ?? 0}
          status={order?.status ?? ''}
          onTestSelect={handlePackageTestSelect}
          onChange={handleTestNameChange}
        />
      )
    }

    if (newRow?.mode?.value === modes?.test) {
      return (
        <Autocomplete
          options={testNameOptions?.map((option) => ({
            ...option,
            isDisabled: rows?.some(
              (row) => row?.testName?.value === option?.value
            ),
            odoo_test_id: option?.odoo_testId,
          }))}
          value={newRow?.testName || null}
          onChange={(event, newValue) => handleTestNameChange(newValue)}
          getOptionLabel={(option) => option?.label || ''}
          getOptionDisabled={(option: any) => option?.isDisabled || false}
          isOptionEqualToValue={(option, value) =>
            option?.value === value?.value
          }
          renderInput={(params) => (
            <TextField {...params} placeholder='Select Test' size='small' />
          )}
        />
      )
    }

    return null
  }

  const handlePackageTestSelect = ({
    packageId,
    productName,
    packagePrice,
    OdooPackageId,
    panels,
  }: {
    packageId: number
    productName: string
    packagePrice: number
    OdooPackageId: any
    panels: Panel[]
  }) => {
    setNewRow((prev: any) => {
      return {
        ...prev,
        packageId,
        packagePrice,
        panels: panels,
        allPanelNames: panels?.map((p) => p?.name)?.join(', '),
        testName: panels?.[0]
          ? { label: panels?.[0]?.name, value: panels?.[0]?.id }
          : null,
        panel: panels?.[0] ?? null,
        productName,
        OdooPackageId,
      }
    })
  }

  return (
    <Box className={classes.container}>
      <Paper elevation={3} className={classes.paper}>
        {/* Header */}
        <Box className={classes.header}>
          <Typography variant='h5' className={classes.headerTitle}>
            Create Lab Order
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Patient UHID: <strong>{muhId}</strong> | FHIR ID:{' '}
            <strong>{fhirId}</strong>
          </Typography>
        </Box>

        <Divider className={classes.divider} />

        {/* Action Bar */}
        <Box className={classes.actionBar}>
          <Box>
            {rows.length > 0 ? (
              <Alert severity='info' className={classes.alert}>
                <strong>{rows.length}</strong> test(s) added. Select payment
                method and submit.
              </Alert>
            ) : (
              <Alert severity='warning' className={classes.alert}>
                No tests added yet. Add tests using the form below.
              </Alert>
            )}
          </Box>

          <Box className={classes.actionButtons}>
            <PaymentMethodSelector
              value={paymentMethod}
              onChange={setPaymentMethod}
              options={paymentOptions}
            />
            <Button
              onClick={handleSave}
              disabled={isSaving || !newrowadded || !paymentMethod?.value}
              variant='contained'
              size='large'
              startIcon={<SaveIcon />}
              className={classes.submitButton}
            >
              {isSaving ? 'Submitting...' : 'Submit Order'}
            </Button>
          </Box>
        </Box>

        {/* Lab Test Table */}
        <LabTestTable
          rows={rows}
          newRow={newRow}
          isRowAdded={isRowAdded}
          priceLoading={priceLoading}
          externalText={externalText}
          testNameOptions={testNameOptions}
          locationPathname={locations.pathname}
          handleModeChange={handleModeChange}
          handleOriginChange={handleOriginChange}
          handleRequestedByChange={handleRequestedByChange}
          setExternalText={setExternalText}
          renderTestOrPackage={renderTestOrPackage}
          renderParameters={renderParameters}
          handleSaveRow={handleSaveRow}
          handleDeleteRow={handleDeleteRow}
          getRequestedByOptions={getRequestedByOptions}
        />
      </Paper>
    </Box>
  )
}

export default CreateLabOrder
